import { render, staticRenderFns } from "./SpaceSelector.vue?vue&type=template&id=9a24e680&scoped=true"
import script from "./SpaceSelector.vue?vue&type=script&lang=ts"
export * from "./SpaceSelector.vue?vue&type=script&lang=ts"
import style0 from "./SpaceSelector.vue?vue&type=style&index=0&id=9a24e680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a24e680",
  null
  
)

export default component.exports